import { Status } from "./Status";


export class PackingBoxStatusSmartEnum {
    static Packed = new Status("Packed", 1, "pill--green");
    static Disposed = new Status("Disposed", 2, "pill--red");
    static Disposing = new Status("Disposing", 3, "pill--orange");
    static Merged = new Status("Merged", 4, "pill--blue");
    static Created = new Status("Created", 5, "pill--grey");
    static Recalled = new Status("Recalled", 6, "pill--blue");
    static Recalling = new Status("Recalling", 20, "pill--blue");
    static Picked = new Status("Picked", 25, "pill--orange");

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "PackingBoxStatusSmartEnum";
    }
}
